import axios from "axios";

import ENV from "../../../../../../../util/env-config";

class Service {
  static initDropbackScan(requestData) {
    return axios.post(ENV.keylockerBase + "/dropback/init", requestData);
  }

  static verifyDropbackScan(requestData) {
    return axios.post(ENV.keylockerBase + "/dropback/verify", requestData);
  }

  static relayError(requestData) {
    return axios.post(ENV.keylockerBase + "/keylockers/relay_error", requestData);
  }

  static openKeyLocker(locker, softmode) {
    if (softmode) {
      if (!this.failed) {
        this.failed = true;
        return Promise.reject({ message: "Softmode: Error opening keylocker box" });
      }

      return Promise.resolve();
    }

    return axios.get(`${ENV.keylockerRelayIPAddress}/state.xml?relay${locker}State=2`);
  }

  static verifyDropbackOpened(requestData) {
    return axios.post(ENV.keylockerBase + "/dropback/opened", requestData);
  }
}

export default Service;
